<template>
  <footer class="footer">
    <div class="footer__container container">
      <div class="row middle g-3">
        <img src="/api/client/logo" width="100" alt="Client logo" class="footer__logo" />
        <a :href="`https://www.${kvassDomainsMap[region.language]}`" target="_blank" v-if="!vendor.id.startsWith('kvass')">
          <div class="small fade mb-1">{{ $t('madeBy') }}:</div>
          <img src="https://manager.kvass.no/api/vendor/kvass/logo" width="100" alt="Kvass Norge AS logo" />
        </a>
      </div>
      <div class="footer__links">
        <a :href="`https://www.${kvassDomainsMap[region.language]}`" target="_blank" class="footer__copyright"
          >&copy; {{ year }} Kvass</a
        >
        <a href="/api/terms/docs/latest/document" target="_blank">{{ $t('termsCondition') }}</a>
        <a :href="`https://legal.kvass.no/privacy/${region.value.toLowerCase()}`" target="_blank">{{
          $t('privacyPolicy')
        }}</a>
        <a :href="`https://legal.kvass.no/cookie/${region.value.toLowerCase()}`" target="_blank">{{
          $t('cookiePolicy')
        }}</a>
      </div>
      <div class="footer__social-icons">
        <a href="https://www.facebook.com/Kvass.no" target="_blank">
          <FontAwesomeIcon :icon="['fab', 'facebook']" size="lg" />
        </a>
        <a href="https://www.linkedin.com/company/kvass" target="_blank">
          <FontAwesomeIcon :icon="['fab', 'linkedin']" size="lg" />
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
import { Clone } from '@/utils'
import { mapState } from 'vuex'

const kvassDomainsMap = {
  en: 'kvass.io',
  da: 'kvass.dk',
  sv: 'kvass.se',
  nb: 'kvass.no',
}
export default {
  props: {
    navigation: Array,
  },
  data() {
    return {
      year: new Date().getFullYear(),
      kvassDomainsMap,
    }
  },
  computed: {
    ...mapState(['vendor']),
    region() {
      return this.$path('$store.state.enums.Region') || { value: 'NO' }
    },
    items() {
      return this.navigation.reduce((res, cur) => {
        if (cur.id === 'business-site') return res

        let add = item => {
          item = Clone(item)
          if (item.icon) item.icon = ['fal', item.icon.pop()]
          res.push(item)
        }
        if (cur.items) cur.items.forEach(add)
        if (cur.action) add(cur)

        return res
      }, [])
    },
  },
}
</script>

<style lang="scss">
.footer {
  background-color: #eaeaea;
  color: black;

  &__container {
    padding-block: 2rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 2rem;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  &__social-icons {
    display: flex;
    gap: 1rem;
    align-items: center;
  }

  &__links {
    display: flex;
    align-items: center;

    a {
      & + a {
        &:before {
          content: '·';
          margin: 3px 10px;
        }
      }
    }
  }
}
</style>
